import React from "react";
import { Switch } from "antd";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { Label } from "../globals";

const SwitchComp = ({
  label,
  name,
  disabled = false,
  number,
  placeholder,
  blockSize,
  checked,
  onChange,
  checkedChildren,
  unCheckedChildren,
  inlineText,
  className = "form-group",
  text,
  labelClassName = "",
  classNameContainer = "",
}) => {
  return (
    <div
      className={className}
      style={blockSize ? { width: `${blockSize}` } : {}}
    >
      {[!!placeholder, !!label].includes(true) && (
        <Label className={labelClassName}>{placeholder || label}</Label>
      )}
      <div className={`d-flex align-items-center ${classNameContainer}`}>
        {inlineText && (
          <div className="text-xs mr-2 text-silver">{inlineText} </div>
        )}
        <Switch
          className={inlineText ? "switch-blue" : ""}
          disabled={disabled}
          checkedChildren={checkedChildren || <AiOutlineCheck />}
          unCheckedChildren={unCheckedChildren || <AiOutlineClose />}
          checked={checked}
          onChange={onChange}
        />
        {text && <div className="ml-2 text-xs">{text}</div>}
      </div>
    </div>
  );
};

export default SwitchComp;
